export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Zero-Log Policy',
      description: 'We never track, collect, or share your private data. Your online activity remains completely anonymous and secure.',
      featured: true,
      gradient: true
    },
    {
      icon: 'ri-server-line',
      title: 'Global Network',
      description: 'Access servers in over 60 countries worldwide for unrestricted browsing and optimal performance.',
      featured: false,
      gradient: false
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Ultra-Fast Speeds',
      description: 'Experience lightning-fast connection speeds with unlimited bandwidth for streaming and downloads.',
      featured: false,
      gradient: false
    },
    {
      icon: 'ri-lock-2-line',
      title: 'Military-Grade Encryption',
      description: 'AES-256 encryption protects your data from hackers, ISPs, and government surveillance.',
      featured: false,
      gradient: false
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect up to 10 devices simultaneously across all platforms - Windows, Mac, iOS, Android, and Linux.',
      featured: false,
      gradient: false
    }
  ];

  return (
    <section id="features" className="py-24 bg-[#F8FAFB]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-[#00D4FF] text-sm font-semibold tracking-[3px] uppercase">
            WHY CHOOSE VIAPREC
          </span>
          <h2 className="text-5xl md:text-6xl font-bold text-[#0A1628] mt-4">
            Military-Grade Protection
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`${
                feature.featured
                  ? 'md:row-span-2 bg-gradient-to-br from-[#0A1628] to-[#1a3a5c] text-white'
                  : 'bg-white text-gray-800 border-l-4 border-[#00D4FF]'
              } rounded-2xl p-8 hover:shadow-xl hover:-translate-y-2 transition-all duration-300 cursor-pointer relative overflow-hidden`}
            >
              {feature.featured && (
                <div className="absolute inset-0 opacity-5">
                  <div className="grid grid-cols-8 gap-4 h-full">
                    {[...Array(64)].map((_, i) => (
                      <div key={i} className="border border-white"></div>
                    ))}
                  </div>
                </div>
              )}
              
              <div className="relative z-10">
                <div
                  className={`w-16 h-16 flex items-center justify-center rounded-2xl mb-6 ${
                    feature.featured
                      ? 'bg-white/10'
                      : 'bg-[#00D4FF]/10'
                  }`}
                >
                  <i
                    className={`${feature.icon} ${
                      feature.featured ? 'text-white' : 'text-[#00D4FF]'
                    }`}
                    style={{ fontSize: feature.featured ? '48px' : '36px' }}
                  ></i>
                </div>
                
                <h3
                  className={`${
                    feature.featured ? 'text-3xl' : 'text-2xl'
                  } font-bold mb-4`}
                >
                  {feature.title}
                </h3>
                
                <p
                  className={`${
                    feature.featured ? 'text-gray-300' : 'text-gray-600'
                  } leading-relaxed`}
                >
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
